import { render, staticRenderFns } from "./RelearnHeader.vue?vue&type=template&id=3babb4f6"
import script from "./RelearnHeader.vue?vue&type=script&lang=js"
export * from "./RelearnHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports